<template>
    <div class="mt-5 w-full flex align-items-center justify-content-center">

        <div class="w-full flex flex-column align-items-center p-6" style="color: var(--theme-font-color); min-width: 15rem; max-width: 35rem; width: 88vw; border: 1px solid var(--theme-color5); border-radius: 18px;">
            <span style="color: var(--theme-font-color); font-size: var(--register-maintitle-font-size); font-weight: var(--register-maintitle-font-weight);" class="text-center">Sign In</span>
            
            <div class="mt-5 flex-column align-items-center" style="gap: 0.7rem; width: 100%;" :class="{ 'flex': !httpLoginLoading, 'hidden': httpLoginLoading}">
                <!--<span v-if="accountNotValidMessage" class="align-self-start error-message mb-2 flex align-items-center gap-1" style="color: var(--inputcomponent-invalid-color);">
                    {{ accountNotValidMessage }}
                    <div class="flex align-items-center" v-tooltip.top="{ value:`Note: Store and Help Desk accounts are separate and won't work here. To access the License Manager, please create a new account if you haven’t already.` }">
                        <SvgInfoCircle className="pluscircle-svg" color="var(--inputcomponent-invalid-color)"/>
                    </div>
                </span> -->
                <span v-if="accountNotValidMessage" class="align-self-start error-message mb-2 flex flex-column align-items-left justify-content-center gap-1" style="color: var(--inputcomponent-invalid-color);">
                    {{ accountNotValidMessage }}
                    <span>
                        <strong>Important</strong>: Your <strong>Softron Online Store</strong> or <strong>Help Desk</strong> accounts <strong>do not work</strong> here! These services are <strong>separate</strong> from the <strong>Softron License Manager</strong> platform.
                    </span>
                </span>         
                <div class="registerlogin-section">
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Email<span style="color: var(--mydanger-color);">*</span></span>
                        <InputText class="w-full register-inputtext" v-model="email" aria-describedby="admin-help" :class="{ 'p-invalid': (errorEmailMessage && isValidEmail(email)!=='success') || accountDoesntExist }" type="email" name="email" autocomplete="username"/>
                        <span v-if="errorEmailMessage" class="error-message" style="color: var(--inputcomponent-invalid-color);">{{ errorEmailMessage }}</span>
                        <span v-if="accountDoesntExist" class="error-message" style="color: var(--inputcomponent-invalid-color);">This account does not exist. Register instead.</span>
                    </div>
                </div>
                <div class="registerlogin-section gap-1">
                    <div class="registerlogin-subsection relative">
                        <span class="subtitle">Password<span style="color: var(--mydanger-color);">*</span></span>
                        <PasswordInputText v-model:val="password" class="register-password" uid="passwordRegister" @update-val="(val) => password=val" :isInvalid="(errorPasswordMessage && isValidPasswordLogin(password)!=='success') || wrongPassword" type="password" name="password" autocomplete="current-password"/>
                        <span v-if="errorPasswordMessage" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">{{ errorPasswordMessage }}</span>
                        <span v-if="wrongPassword" class="error-message mb-2" style="color: var(--inputcomponent-invalid-color);">The password is incorrect.</span>
                    </div>
                </div>
                <div class="flex flex-row my-4 gap-1 align-items-center">
                    <Checkbox v-model="rememberMe" :binary="true"/>
                    <span style="font-size: var(--register-text-font-size); font-weight: var(--register-text-font-weight);">Remember Me</span>
                </div>
                <TurnstileWidget widgetId="loginTurnstileWidget" @human-verified="(token) => {turnstileToken = token; isHumanVerified = true}"/>
                <div class="flex flex-column w-full gap-2 align-items-center">
                    <ButtonModule type="primary" severity="normal" label="Sign In" @click="clickedLogin(email, password)" :disabled="!enableLogin" class="mb-4"/>
                    <span style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">
                        Don't have an account?
                        <router-link unstyled :to="{ path: '/register'}" style="text-decoration: none;">
                            <span id="go-to-register-text" class="cursor-pointer" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);">Register.</span>
                        </router-link>
                    </span>
                    
                    <span id="forgot-password-text" :class="{'cursor-pointer': isHumanVerified, 'disabled': !isHumanVerified}" style="font-size: var(--register-subtext-font-size); font-weight: var(--register-subtext-font-weight);" @click="if (isHumanVerified) { showForgotPasswordDialog = true; }" v-tooltip.bottom="{ value: isHumanVerified ? '' : 'Please verify you\'re human to proceed.', showDelay: 800 }">Forgot Password?</span>
                </div>
            </div>

            <div v-if="httpLoginLoading" style="height: 40vh;" class="flex align-items-center justify-content-center">
                <LoadingSpinner/>
            </div>
        </div>

        <!-- DIALOGS -->

        <!-- Forgot Password window -->
        <ForgotPasswordDialog :showDialog="showForgotPasswordDialog" :currentEmail="email" @close="showForgotPasswordDialog = false"/>
    </div>
</template>

<script setup>
// --- IMPORTS ---
import { ref, watchEffect, computed, onMounted, onBeforeUnmount } from 'vue';
// PrimeVue
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
// vue
import PasswordInputText from '@/components/Modules/PasswordInputText.vue'
import ButtonModule from '@/components/Modules/ButtonModule.vue'
import ForgotPasswordDialog from '@/components/Dialogs/OtherDialogs/ForgotPasswordDialog.vue'
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
import TurnstileWidget from '@/components/Modules/TurnstileWidget.vue';
import SvgInfoCircle from '@/components/SVGs/SvgInfoCircle.vue';
// Others
import InputsUtils from '@/composables/InputsUtils'
import toastService from '@/composables/toastService';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';
import UserUtils from '@/composables/UserUtils'

// API
import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchLogin } = useApiRequest()
const httpLoginLoading = ref(false)
const httpLoginData = ref(null)

const router = useRouter()
const store = useStore()
const { isValidEmail, isValidPasswordLogin } = InputsUtils()
const { loginUser } = UserUtils(store, router)

// --- REDIRECT IF ALREADY CONNECTED ---
const isLoggedIn = computed(() => store.getters['user/isLoggedIn'])
watchEffect(() => {
    if (isLoggedIn.value) { router.push({ path: '/licenses' }) }
})

// --- EMITS ---
const emit = defineEmits(['login'])

// --- VARIABLES ---
const rememberMeEmailStorageLabel = 'remember-me-email'
const email = ref(localStorage.getItem(rememberMeEmailStorageLabel))
const password = ref(null)

// Errors
const errorEmailMessage = ref(null)
const errorPasswordMessage = ref(null)
const accountDoesntExist = ref(false)
const wrongPassword = ref(false)
const accountNotValidMessage = ref(null)

// --- Remember me ---
const rememberMe = ref(true)

// --- Click login ---
const enableLogin = computed(() => isHumanVerified.value && email.value && password.value)
const clickedLogin = async (myEmail, myPassword) => {
    errorEmailMessage.value = null
    errorPasswordMessage.value = null
    accountDoesntExist.value = false
    wrongPassword.value = false
    accountNotValidMessage.value = null
    var validSubmit = true

    // Check if valid Email
    const isValidEmailMessage = isValidEmail(myEmail)
    if (isValidEmailMessage !== 'success') { errorEmailMessage.value = isValidEmailMessage; validSubmit = false }
    // Check if valid Password
    const isValidPasswordMessage = isValidPasswordLogin(myPassword)
    if (isValidPasswordMessage !== 'success') { errorPasswordMessage.value = isValidPasswordMessage; validSubmit = false }

    // If the conditions are ok : go on
    if (!validSubmit) {
        password.value = null
        return
    }
    errorEmailMessage.value = null
    errorPasswordMessage.value = null

    // Remember Me
    if (!rememberMe.value) { // Remove what is stored in localStorage for the email
        localStorage.removeItem(rememberMeEmailStorageLabel)
    }

    // Send HTTP request
    httpLoginLoading.value = true
    try {
        httpLoginData.value = await fetchLogin({email: myEmail, password_plain: myPassword, cf_turnstile_response : turnstileToken.value })

        // Remember Me
        if (rememberMe.value) { // Store the email in localStorage
            localStorage.setItem(rememberMeEmailStorageLabel, myEmail)
        }

        // Reset of values
        email.value = null
        password.value = null
        accountDoesntExist.value = false
        wrongPassword.value = false
        // Login the user
        loginUser(httpLoginData.value)
        // Redirect to /licenses
        router.push({ path: '/licenses' })

    } catch (err) {
        window.turnstile.reset("#loginTurnstileWidget")
        handleLoginError(err)
    } finally {
        password.value = null
        httpLoginLoading.value = false
    }
}
// Handle an error from the server
const handleLoginError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Login: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // Missing info = MISSING_OBJ / MISSING_OBJ_ELEM (400) => toast
                if (errorCode == 'MISSING_OBJ' || errorCode == 'MISSING_OBJ_ELEM') {
                    toastService.add({ severity: 'warn', summary: "Login: Missing Information.", detail: 'It seems that the request body does not contain the necessary information.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 401: // Invalid account (either account does not exist or the password is wrong = ACCOUNT_NOT_VALID (401)
                if (errorCode == 'ACCOUNT_NOT_VALID') {
                    accountNotValidMessage.value = errorMessage
                } else if (errorCode == 'CLOUDFLARE_TURNSTILE_INVALID') {
                    toastService.add({ severity: 'error', summary: `Login: Cloudflare Verification Error.`, detail: "The Cloudflare verification is no longer valid — this can happen if too much time passes before submitting. Please redo the verification and try again.", life: 10000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 403: // Account registered but not validated (check mails) = ACCOUNT_NOT_CONFIRMED (403) => toast
                if (errorCode == 'ACCOUNT_NOT_CONFIRMED') {
                    toastService.add({ severity: 'warn', summary: "Login: Account Not Confirmed.", detail: 'The account is registered but not validated yet. Please check your emails to confirm the registration.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            case 500: // DATABASE_ERROR (500) => toast
                if (errorCode == 'DATABASE_ERROR') {
                    toastService.add({ severity: 'error', summary: "Login: Internal Error.", detail: 'Sorry, it seems that there is an internal error. Try later.', life: 5000 });
                }
                else {  toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Login: Error ${errorStatus}.`, detail: errorMessage, life: 12000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Login: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}

// --- Forgot Password Popup ---
const showForgotPasswordDialog = ref(false)

// --- ENTER key listener ---
onMounted(() => {
    window.addEventListener('keydown', handleKeyPressed)
})
onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyPressed)
}) 
const handleKeyPressed = (event) => {
    if (!showForgotPasswordDialog.value && event.keyCode === 13) { // ENTER
        if (enableLogin.value) { clickedLogin(email.value, password.value) }
    }
}

// --- TURNSTILE ---
const turnstileToken = ref(null)
const isHumanVerified = ref(false) // turnstile
</script>

<style scoped>
/* Label */
.subtitle {
    font-size: var(--register-subtitle-font-size);
    font-weight: var(--register-subtitle-font-weight);
    opacity: 0.7;
}
/* InputText */
:deep(.p-inputtext) {
    height: 2.5rem
}
/* Checkbox */
:deep(.p-checkbox .p-checkbox-box) {
    width: 1rem;
    height: 1rem;
    align-self: center;
}
:deep(.p-checkbox .p-checkbox-box .p-icon) {
    width: 0.6rem;
    height: 0.6rem;
}
/* Go to register */
#go-to-register-text {
    text-decoration: none;
    color: var(--button-normal-color);
}
#go-to-register-text:visited {
    color: var(--button-normal-color);
}
#go-to-register-text:hover {
    border-bottom: 1px solid var(--button-normal-color);
}
/* Forgot password */
#forgot-password-text {
    text-decoration: none;
    color: var(--button-normal-color);
    border-bottom: 1px solid transparent;
}
#forgot-password-text.disabled {
    opacity: 0.6;
}
#forgot-password-text:hover:not(.disabled) {
    border-bottom: 1px solid var(--button-normal-color);
}
</style>